import { v3 } from "oc-threejs/short3";
import Scenes from "oc-threejs/Scenes";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import BaseType from "./BaseType";

export default class Raum extends BaseType(THREE.Group) {
    vsUpdate() {
        if (this.isVsChanged("size")) {
            Scenes.empty(this);
            this.createRoom();
        }
    }

    createRoom() {
        const breite = this.vsData.size.x;
        const hoehe = this.vsData.size.y;
        const tiefe = this.vsData.size.z;

        let wandMaterial, bodenMaterial;
        if (this.vsData.bodenMaterialName) {
            bodenMaterial = UniversalLoader.getMaterialFactory().create(this.vsData.bodenMaterialName);
            bodenMaterial.map.repeat.set(breite * 0.01, tiefe * 0.01)
        } else {
            bodenMaterial = new THREE.MeshStandardMaterial({
                color: "FFFFFF",
                side: THREE.BackSide,
            });
        }

        if (this.vsData.wandMaterialName) {
            wandMaterial = UniversalLoader.getMaterialFactory().create(this.vsData.wandMaterialName);
            wandMaterial.map.repeat.set(breite * 0.01, hoehe * 0.01)
        } else {
            wandMaterial = new THREE.MeshStandardMaterial({
                color: "FFFFFF",
                side: THREE.BackSide,
            });
        }

        //TODO: SETTINGS!
        // let wandMaterial, bodenMaterial;
        // if (APP.settings.textureAtWallAndFloor) {
        //     const bodenTextureMap = APP.model.loadTexture(APP.contentBaseUrl + "textures/floor_map.jpg", 4, 4);
        //     bodenTextureMap.wrapS = bodenTextureMap.wrapT = THREE.MirroredRepeatWraping;
        //     const wallTextureMap = APP.model.loadTexture(APP.contentBaseUrl + "textures/wall_map.jpg", 200, 200);
        //     bodenMaterial = new THREE.MeshStandardMaterial({
        //         map: bodenTextureMap,
        //         // color: APP.settings.getInt("raum_boden_farbe"),
        //         side: THREE.BackSide,
        //         envMapIntensity: 0.75,
        //     });
        //     wandMaterial = new THREE.MeshStandardMaterial({
        //         map: wallTextureMap,
        //         // emissive: new THREE.Color(128, 128, 128),
        //         side: THREE.BackSide,
        //         envMapIntensity: 0.75,
        //     });
        // } else {
        //     bodenMaterial = new THREE.MeshStandardMaterial({
        //         // TODO
        //         color: "FFFFFF" /* APP.settings.getInt("raum_boden_farbe") */,
        //         side: THREE.BackSide,
        //     });
        //     wandMaterial = new THREE.MeshStandardMaterial({
        //         // TODO
        //         color: "FFFFFF"/* APP.settings.getInt("raum_wand_farbe") */,
        //         side: THREE.BackSide,
        //     });
        // }
        const deckeMaterial = new THREE.MeshStandardMaterial({
            color: "FFFFFF",
            side: THREE.BackSide,
        });
        const materials = [wandMaterial, wandMaterial, deckeMaterial, bodenMaterial, wandMaterial, wandMaterial];

        const wallsAndFloor = new THREE.Mesh(new THREE.BoxGeometry(breite, hoehe, tiefe), materials);
        wallsAndFloor.receiveShadow = true;
        wallsAndFloor.name = "Raum";
        wallsAndFloor.position.copy(this.vsData.position);
        this.add(wallsAndFloor);

        // wallsAndFloor.visible = !APP.settings.localDevelopmentMode;

        //TODO: SETTINGS!
        if (APP.settings.getBool("fussleiste")) {
            // funktioniert nicht mit overSize
            const fl = {
                dicke: APP.settings.getMinValue("fussleiste_dicke"),
                hoehe: APP.settings.getMinValue("fussleiste_hoehe"),
                material: new THREE.MeshStandardMaterial({
                    color: APP.settings.getValue("fussleiste_material"),
                    side: THREE.DoubleSide,
                }),
            };

            const box = (sx, sy, sz, px, py, pz, material) => {
                const b = Scenes.box(v3(sx, sy, sz), material);
                b.position.set(px, py, pz);
                return b;
            };

            this.add(box(fl.dicke, fl.hoehe, tiefe, -breite / 2 + fl.dicke / 2, fl.hoehe / 2, tiefe / 2, fl.material));
            this.add(box(fl.dicke, fl.hoehe, tiefe, breite / 2 - fl.dicke / 2, fl.hoehe / 2, tiefe / 2, fl.material));
            this.add(box(breite, fl.hoehe, fl.dicke, 0, fl.hoehe / 2, fl.dicke / 2, fl.material));
        }
    }
}
